export default "__VITE_ASSET__C_SXMTg0__"